function Header() {
  return (
    <nav>
      <div className="orange nav-wrapper">
        <a href="#!" class="brand-logo center">Movies App</a>
        <ul className="left hide-on-med-and-down">
          {/* <li>
            <a href="">Sass</a>
          </li>
          <li>
            <a href="">Components</a>
          </li>
          <li>
            <a href="">JavaScript</a>
          </li> */}
        </ul>
      </div>
    </nav>
  );
}

export { Header };
